import { IsBoolean } from "class-validator";

export class GetSupportResult {
    @IsBoolean()
    public success: boolean;
}